// This file is generated. Do not modify it.
// See: packages/pulse/scripts/transpile-variables.ts
export const gradients = {
  read: "linear-gradient(48.38538393675617deg, #4361ee 0%, #7a61ff 100%)",
  negative: "linear-gradient(134.12149941872758deg, #b66a5a 0%, #e48570 100%)",
  success: "linear-gradient(134.1159595199618deg, #67a166 0%, #81c980 100%)",
  information:
    "linear-gradient(134.11595984875146deg, #364ebf 0%, #4462ef 100%)",
  data: "linear-gradient(103.58314532892643deg, #e99d8d 0%, #7a61ff 100%)",
  accent: "linear-gradient(307.5671629222934deg, #b0637a 0%, #624ecc 100%)",
  highlight: "linear-gradient(43.82632466823509deg, #e29201 0%, #eda525 100%)",
  brand: "linear-gradient(48.38538393675617deg, #4462ef 0%, #4c47cc 100%)",
  ghost: "linear-gradient(180deg, #f0f0f8 0%, #ffffff 100%)",
  skeleton:
    "linear-gradient(126.07456117178901deg, #e9e9e9 0%, #f2f2f2 51%, #ffffff 100%)",
};

export type Gradients = typeof gradients;
